module.exports = __webpack_public_path__ + "static/media/Rectangle 89.12b33523.png";